import React, {useEffect, useContext} from 'react';
import { Box, Button, Stack, TableCell, TextField, Typography, IconButton, Dialog, Backdrop, CircularProgress } from '@mui/material';
import {Context} from '../App';
import {API} from '../conf';
import SorTableCheckable from '../Components/ui/sortable-checkable';
import { Add, DeleteForever, Edit, InfoOutlined } from '@mui/icons-material';
import Header from '../Components/ui/Header';
import RegionForm from '../AdmComponents/forms/region';

export default function RegionsManager() {
    const {updateConnect} = useContext(Context)
    const [load, setLoad] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [action, setAction] = React.useState('');
    const [regions, setRegions] = React.useState([]);
    const [region, setRegion] = React.useState();
    const [selectItems, setItems] = React.useState([]);
    const [searchInput, setSearchInput] = React.useState('');

    const table = [
        {header: "Code ISO", sortable: true, sortBy:(el)=>el.code.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'uppercase', minWidth:'50px', maxWidth:'80px'}}>{row.code}</TableCell>},
        {header: "Nom", sortable: true, sortBy:(el)=>el.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'200px'}}>{row.nom}</TableCell>},
        {header: "Code postal", sortable: true, sortBy:(el)=>el.zip, row: (row, index)=><TableCell key={index} sx={{maxWidth:'70px', textAlign:'center'}}>{row.zip}</TableCell>},
        {header: "Communes", sortable: true, sortBy:(el)=>el.communes.length, row: (row, index)=><TableCell key={index} style={{minWidth:'50px'}}>{row.communes.length}</TableCell>},
        {header: "Actif sur Esdras7", sortable: true, sortBy:(el)=>el.availableOnEsdras, row: (row, index)=><TableCell key={index} style={{minWidth:'50px'}}>{row.availableOnEsdras?'oui':'non'}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} sx={{minWidth:'180px', textAlign:'end'}} >
            <IconButton aria-label="informations complémentaires" onClick={()=>{setRegion(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" onClick={()=>{setRegion(row); manage_dialog(true, 'delete')}}><DeleteForever fontSize="small"/></IconButton>
            <IconButton aria-label="modifier" onClick={()=>{setRegion(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
        </TableCell>}
    ]

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.nom+' '+item.code+' '+item.zip+' '+item.communes.map(c => c.nom).join(' ')
    }

    function searchFilter(a, b) {
        return normalize(get_searchable(a)).includes(normalize(b))
    }

    function manage_dialog(status, action='') {
        setOpen(status)
        setAction(action)
        if(!status) {
            setRegion()
        }
    }

    async function showResult(result) {
        manage_dialog(true, result ? 'success' : 'echec')
        await new Promise(resolve => setTimeout(resolve, 3000))
        manage_dialog(false)
    }

    useEffect(() => {
        fetch(API.concat('/regions'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                updateConnect(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setRegions(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching regions:", error);
        }).finally(() => {
            setLoad(false);
        });
    }, []);

    return(
        <Box display='flex' flexDirection='column' flex={1} >
            <Header/>
            <Box flex={1} display='flex' flexDirection='column' sx={{padding:2}}>
                <Typography variant='h4' marginBlock={3} align='center'>
                    Gestionnaire de Regions
                </Typography>

                <Stack direction="row" spacing={2} marginBottom={1.5} alignItems='center' justifyContent={'space-between'}>
                    <TextField value={searchInput} onChange={(e)=>setSearchInput(e.target.value)} label="Rechercher une région..." variant="outlined" size="small" sx={{width:'60%'}}/>
                    <Button variant="contained" color="primary" onClick={()=>manage_dialog(true, 'add')} startIcon={<Add/>}>
                        Nouvelle région
                    </Button>
                </Stack>

                <SorTableCheckable {...{data:regions.filter(reg=>searchFilter(reg, searchInput)),table, selectItems, setItems, rowsPerPage:25, rowsPerPageOptions:[10,25,50,100]}}/>
            </Box>

            <Dialog {...{open, onClose:()=>manage_dialog(false), maxWidth:'md', fullWidth:true}}>
                {action === 'add' && <RegionForm {...{close:()=>manage_dialog(false), showResult, setRegions, regions}}/>}
                {action === 'edit' && <RegionForm {...{close:()=>manage_dialog(false), showResult, setRegions, regions, region}}/>}
            </Dialog>

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}